<template>
    <el-collapse-item class="unilateral-item" :name="'collapse'+uindex">
        <template slot="title" v-if="taskData">
            <el-row class="unilateral-item-row">
                <el-col class="strategy-name" @click.native="showStaicData(taskData.id)">{{taskData.names}}</el-col>
                <el-col>
                    <span class="strage_status" v-if="String(userLevel) == '1'"
                    :style="{'background-color': taskData.status == '1' ? '#1aa094': '#db5634'}"
                    >{{strategyStatus[taskData.status]}}</span>
                    <!-- <span class="strage_show_status">{{isShowJurge(taskData.target)}}</span> JSON.parse(taskData.chart_data) v-if="taskData.chart_data"-->
                </el-col>
                <el-col class="money_algin_style">{{dataHandle(taskData.total_eq)}}%</el-col>
                <el-col>
                    <el-tooltip placement="top">
                        <div slot="content" class="position__tip" v-loading="loadingFlag" v-if="taskData.position">
                            <div class="position-item">
                                <span class="position_title">币种/合约</span>
                                <span>{{taskData.position.coin_names}}</span>
                            </div>
                            <div class="position-item">
                                <span class="position_title">仓位</span>
                                <span>{{(taskData.position.position).toFixed(6)}}</span>
                            </div>
                            <div class="position-item">
                                <span class="position_title">成本</span>
                                <span>{{(taskData.position.cost).toFixed(6)}}</span>
                            </div>
                            <div class="position-item">
                                <span class="position_title">持仓占比(%)</span>
                                <span>{{(taskData.position.ratio).toFixed(2)}}</span>
                            </div>
                            <div class="position-item">
                                <span class="position_title">开仓方向</span>
                                <span>{{taskData.position.type}}</span>
                            </div>
                        </div>
                        <el-button class="table-btn">持仓<i class="fa fa-btc" aria-hidden="true"></i></el-button>
                    </el-tooltip>
                    <!-- <span>持仓<i class="fa fa-btc" aria-hidden="true"></i></span>:chartData="JSON.parse(taskData.chart_data)" -->
                </el-col>
                <el-col>
                    <div style="width: 138px; height: 44px;"
                    element-loading-background="rgba(0, 0, 0, 0)"
                    >
                        <TrendChart v-if="unilSChartData.length !== 0" :chartData="unilSChartData[uindex]"
                        @changeLoad="changeLoading" @click.native.stop="stopEvent"></TrendChart>
                    </div>
                </el-col>
                <el-col>{{taskData.update_time}}</el-col>
                <el-col>{{taskData.last_deal}}</el-col>
                <el-col>
                    <el-dropdown trigger="click" v-if="userLevel == 1">
                        <el-button class="table-btn task_btn_style" @click.stop.prevent>操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-btnpermission="'strategy_start'" @click.native="operStrategy('start', taskData.id)">启动</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_stop'" @click.native="operStrategy('stop', taskData.id)">停止</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_update'" @click.native="addStrategy('edit', taskData.id)">编辑</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_all_preserve'" @click.native="restoreAllTask(taskData.id)">一键保值</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_details'" @click.native="showStaicData(taskData.id)">详情</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_add_task'" @click.native="addTask(taskData)">添加任务</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_hide'" :class="{'UTaskSelected': taskData.target == '0'}" @click.native="showStrategy(taskData.id, '0')">隐藏</el-dropdown-item>
                            <el-dropdown-item v-btnpermission="'strategy_show'" :class="{'UTaskSelected': taskData.target == '1'}" @click.native="showStrategy(taskData.id, '1')">展示</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </template>
        <div v-if="isRender">
            <div v-for="(ctask, index) in taskData.task_ids" :key="'ctask_'+index">
                <CtaskItem :ctaskData="getCtaskData(ctask)"></CtaskItem>
            </div>
        </div>
    </el-collapse-item>
</template>

<script>
import { mapState } from "vuex";
import { put, post } from "@/api/index";
import { possRestoreAllTask } from "@/api/api";
import TrendChart from "@/components/unilateral/Unilateral-lchart.vue";
import CtaskItem from "@/components/unilateral/Unilateral-ctask.vue";

export default {
    components: {
        TrendChart,
        CtaskItem
    },
    data: function () {
        return {
            taskColName: [
                { title: "用户", key: "user" },
                { title: '杠杆率(%)', key: 'ratio' },
                { title: '备注', key: 'names' },
                { title: '策略名', key: 'strategy' },
                { title: '状态', key: 'status' },
            ],
            strategyStatus: ['暂停', '运行'],
            loadingFlag: true,
            isRender: false
        }
    },
    props: [
        "taskData",
        "apiData",
        "uindex",
        "formData"
    ],
    mounted() {

    },
    computed: {
        ...mapState([
            "userLevel",
            "token",
            "unilSChartData"
        ]),
    },
    methods: {
        dataHandle(data) {
            return Number(data).toFixed(2)
        },
        
        // 子任务数据获取
        getCtaskData(id) {
            for (var i=0; i<this.apiData.length; i++) {
                if (this.apiData[i].id == id) {
                    return this.apiData[i];
                }
            }
        },

        // 操作函数
        operStrategy(flag, sid) {
            let url = this.$url_LN_local + '/put/strategy/state';
            let param = {
                'token': this.token,
                'strategyIds': [sid],
            };

            if (flag == 'start') {
                param['state'] = 1;
            } else if (flag == 'stop') {
                param['state'] = 0;
            }

            put(url, param).then(res => {
                if (res.code !== 200) {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 编辑窗口
        addStrategy(flag, id) {
            this.$emit("showEdit", flag, id);
        },

        // 详情展示
        showStaicData(sid) {
            this.$router.push({
                path: '/unilateral/statistic',
                query: {
                    key: sid
                }
            });
        },

        // 改变loading的值
        changeLoading(flag) {
            this.loadingFlag = flag;
        },

        // 是否展示判断
        isShowJurge(flag) {
            if (flag == '1') {
                return "展示";
            } else if (flag == '0') {
                return "隐藏";
            }
            return '---';
        },

        // 策略是否展示测试
        showStrategy(id, flag) {
            var url = this.$url_LN_local + "/show/is/strategy";
            var param = {
                'token': this.token,
                "strategyId": id,
                "target": flag
            };

            post(url, param).then(res => {
                if (res.code === 200) {
                    this.$notify.info({
                        message: res.info,
                        title: "提示",
                        offset: 200
                    });
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 200
                    });
                }
            })
        },

        // 添加任务
        addTask(data) {
            this.$emit('addTask', data.id, data.names);
        },

        // 阻止事件传递
        stopEvent() {
            console.log('阻止事件传递');
        },

        handleCTaskData(data) {
            if (this.isRender) {
                return data;
            }
            return [];
        },
        renderChild(flag) {
            this.isRender = flag;
        },
        // 一键保值/跟随
        restoreAllTask(taskId) {
            this.$confirm('是否一键跟随？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                possRestoreAllTask({
                    token: this.token,
                    strategyId: taskId,
                    type: 1
                }).then(res => {
                    this.$notify.info({
                        title: '提示',
                        message: res.info,
                        offset: 200
                    });
                })
            }).catch(() => {
                
            })
        }
    }
}
</script>

<style lang="scss">

.position__tip {
    color: #a8a7a9;
    .position_title {
        text-align: right;
        min-width: 70px;
        display: inline-block;
        margin-right: 10px;
    }

    .position-item {
        padding: 3px;
    }
}

.UTaskSelected{
    color: #1e87da !important;
}

.unilateral-item {
    background-color: #2a2d2e;
    color: #a8a7a9;
    border-bottom: 1px solid #1e1e1e;
    .unilateral-item-row {
        display: flex;
    }
    .unilateral-item-row>div{
        flex: 1;
    }

    .task_max_len {
        max-width: 147px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .money_algin_style {
        text-align: left;
    }

    .task_btn_style {
        margin: 3px;
        font-size: 12px;
    }

    .table-btn {
        background-color: #333333;
        border-color: #333333;
        padding: 8px 14px;
    }
    
    .strage_status {
        border-radius: 3px;
        color: #fff;
        padding: 3px 0px;
        box-sizing: border-box;
        display: inline-block;
        line-height: 18px;
        // width: 16px;
        font-size: 12px;
        vertical-align: middle;
    }

    .strage_show_status {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        // padding: 3px 1px;
    }

    .el-collapse-item__header, .el-collapse-item__wrap {
        background-color: transparent;
        border-color: #2a2d2e;
        color: #a8a7a9;
        .el-collapse-item__content {
            color: #a8a7a9;
        }
    }

    .el-collapse-item__content {
        padding-bottom: 0;
    }

    .el-row{
        width: 100%;
        background-color: transparent;
        margin: 0 !important;
        .strategy-name {
            // max-width: 164px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-left: 10px;
        }
        .el-col {
            text-align: left;
        }
    }

    .el-loading-spinner .circular {
        height: 20px;
        width: 20px;
    }
}

.unilateral-item:hover {
    background-color: #343535;
}
</style>
 